export const BOOKINGS_REQUEST_FINISH_SUBMIT_REQUEST = 'bookings/request-finish-submit-request'
export const BOOKINGS_REQUEST_FINISH_SUBMIT_SUCCESS = 'bookings/request-finish-submit-success'
export const BOOKINGS_REQUEST_FINISH_SUBMIT_FAILED = 'bookings/request-finish-submit-failed'
